import { Injectable } from '@angular/core';
import { CreateCartSuccessPayload, CustomCart } from '@cart/const';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CartActions } from '../store/actions';
import { StateWithCustomCart } from '../store/cart-state';
import { CustomCartSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class CustomMultiCartFacade {
  constructor(private store: Store<StateWithCustomCart>) {}

  // чекает корзинку на бэке и записывает в список корзин, если она есть
  restoreCart(cart: CustomCart, active: boolean): void {
    this.store.dispatch(new CartActions.RestoreCart({ cart, active }));
  }

  cloneCart(cartGuid: string): void {
    this.store.dispatch(new CartActions.CloneCart({ cartGuid }));
  }

  safelySetActiveCartId(cartId: string): void {
    this.store.dispatch(new CartActions.SafelySetActiveCartId(cartId));
  }

  getTemporaryCartIdValue(): Observable<string> {
    return this.store.pipe(select(CustomCartSelectors.getTemporalyCartIdValue));
  }

  clearTemporaryCartId(): void {
    this.store.dispatch(new CartActions.ClearTemporaryCartId());
  }

  clearCartState(): void {
    this.store.dispatch(new CartActions.ClearCartState());
  }

  addCartToList(payload: CreateCartSuccessPayload): void {
    const { cart, tempCartId, userId, cartId, active = true } = payload;
    this.store.dispatch(
      new CartActions.CreateCartSuccess({
        extraData: { active },
        cart,
        tempCartId,
        userId,
        cartId,
      }),
    );
  }

  removeCart(cartId: string): void {
    this.store.dispatch(
      new CartActions.RemoveCart({
        cartId,
      }),
    );
  }

  removeAllEntries(userId: string, cartId: string): void {
    this.store.dispatch(
      new CartActions.RemoveAllCartEntries({
        userId,
        cartId,
      }),
    );
  }
}
